module.exports = "<div *ngIf=\"initialized\" class=\"paginator btn-group btn-group-sm\">\r\n    <button *ngFor=\"let opt of opts\" type=\"button\" [class.active]=\"opt.value == currentPage\" class=\"btn btn-primary\" [disabled]=\"opt.disabled\"\r\n        (click)=\"paginate(opt.value)\">{{opt.display}}</button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/WORK/Projects/ActNow_NG2/src/app/common/datatable-paginator/datatable-paginator.component.html
// module id = ../../../../../src/app/common/datatable-paginator/datatable-paginator.component.html
// module chunks = main